import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const OpportunityCategoryListDetails = () => {
  const columns = [
    { label: 'Name', value: 'name' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];
  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/opportunity/category/details/' + encodedId;
  };
  return <ListTemplate fetchUrl={API_DOMAIN + API_ROUTES['opportunityCategory']} columns={columns} onAccessDetails={handleAccessDetails} />;
};

export default OpportunityCategoryListDetails;